<div class="main column"><h1>{{"faq_title" | translate}}</h1><iframe [src]="getIframeSrc()"></iframe></div>